<template>
  <div class="checkbox" :class="{'checkbox--dark': type === 'dark', 'checkbox--light': type === 'light', 'checkbox--filled': filled, 'checkbox--simple-question': simpleQuestion}">
    <input @change="$emit(`input`, $event.target.checked)"
           :id="name"
           :checked="value"
           :disabled="disabled"
           type="checkbox"
           class="checkbox__input visually-hidden">
    <label :for="name" class="checkbox__label">
      <span class="checkbox__text">{{ label }}</span>
      <slot></slot>
    </label>
  </div>
</template>

<script>
export default {
  name: 'Checkbox',
  props: {
    name: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: false
    },
    value: {
      type: Boolean,
      required: false
    },
    type: {
      type: String,
      default: 'light'
    },
    filled: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    simpleQuestion: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="sass" scoped>

.checkbox
  position: relative

  &--simple-question
    margin: 0 0 20px

    +mmin($extsmall--hor)
      margin: 0 0 10px

.checkbox__label
  display: block
  padding-left: 35px
  font-weight: 400
  font-size: 14px
  line-height: 20px
  color: $text-color!important

  &:hover
    cursor: pointer
    // color: $nd-link-color

  &:before
    content: ''
    cursor: pointer
    position: absolute
    width: 20px
    height: 20px
    top: 0
    left: 0
    background: #fff
    border: 1px solid #cccccc
    border-radius: 3px

  &:after
    opacity: 0
    content: ''
    position: absolute
    width: 10px
    height: 6px
    background: transparent
    top: 6px
    left: 5px
    border: 2px solid $main-color
    border-top: none
    border-right: none
    transform: rotate(-45deg)

.checkbox__input[type=checkbox]:checked + label:after
  opacity: 1

.checkbox__input[type=checkbox]:hover + label:before,
.checkbox__input[type=checkbox]:focus + label:before
  border-color: $placeholder-color

.checkbox--filled
  .checkbox__label
    &:after
      border-color: $white-text-color

  .checkbox__input[type=checkbox]:checked + label:before
    background: $main-color
    border: none

.checkbox--dark
  .checkbox__label
    color: $white-text-color!important

    &:before
      background: rgba(255,255,255,.1)
      border: 1px solid rgba(255,255,255,.1)

.checkbox__input[type=checkbox]:disabled
  + label:before,
  + label:after
    color: $nd-border-color
    background: $nd-border-color
    border-color: $nd-border-color

  + label .checkbox__text
    color: $placeholder-color

</style>
